import script from "./ProjectManagerChangeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectManagerChangeForm.vue?vue&type=script&setup=true&lang=js"

import "./ProjectManagerChangeForm.vue?vue&type=style&index=0&id=67e6efb6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e6efb6"]])

export default __exports__